import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import AlarmWidgetTable from './AlarmWidgetTable';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAlarmLog } from 'features/alarmLog/api/getAlarmLog';
import { NotificationsNone } from '@mui/icons-material';
import { joinAlarmStopsToStarts } from 'features/alarmLog/utils/logManipulation';
import { SnapshotAlarmLogReturnWithStop } from 'features/alarmLog/types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  analyzerIdFilter?: number | undefined;
  snapshotIdFilter?: number | undefined;
}

const AlarmWidget = ({ analyzerIdFilter, snapshotIdFilter }: Props) => {
  const { monthDayFormat, timezone } = useUserDateTime();
  const todayFormatted = formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd');

  const { data: alarmLog } = useAlarmLog({
    toDate: todayFormatted,
    fromDate: todayFormatted,
    analyzerId: analyzerIdFilter,
    snapshotId: snapshotIdFilter,
    config: {
      refetchInterval: 60000,
    },
  });

  const [formattedAlarmLog, setFormattedAlarmLog] = useState<
    SnapshotAlarmLogReturnWithStop[]
  >([]);

  useEffect(() => {
    if (alarmLog) {
      const responseWithStopsJoined = joinAlarmStopsToStarts(alarmLog);
      setFormattedAlarmLog(responseWithStopsJoined);
    }
  }, [alarmLog]);

  return (
    <Grid item container xs={12} component={Paper} justifyContent={'center'}>
      <Grid item container xs={12} alignItems='center' justifyContent='center'>
        <NotificationsNone />
        <Grid item style={{ marginLeft: '.3rem' }}>
          <Typography
            component='h4'
            variant='h6'
            style={{ textAlign: 'center' }}
          >
            {formatInTimeZone(new Date(), timezone, monthDayFormat)} Daily Alarm
            Log
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography style={{ textAlign: 'center' }}>
          Alarms:
          {' ' + formattedAlarmLog?.length || 0}
        </Typography>
      </Grid>
      {formattedAlarmLog && formattedAlarmLog.length !== 0 ? (
        <Grid container item>
          <AlarmWidgetTable alarmLog={formattedAlarmLog} />
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          style={{
            paddingBottom: '1rem',
            marginLeft: '1rem',
            marginTop: '.2rem',
          }}
        >
          <Typography align='left' variant='body2'>
            No alarm log entries for today.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default AlarmWidget;
